export enum CorporateBadgeType {
  CORPORATE = 'corporate-badge-v2.svg',
  CORPORATE_LIGHT = 'corporate-badge-light-v2.svg',
}
